<template>
  <div class="div-card">
    {{content}}
  </div>
</template>
<script>
export default {
  props: {
    content: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
.div-card {
  width: 100%;
  padding: 0 15px;
  box-sizing: border-box;
  min-height: 30px;
  opacity: 1;
  background: linear-gradient(90deg, rgba(160, 195, 235, 1) 0%, rgba(160, 195, 235, 0) 99.98%);
  font-size: 12px;
  font-weight: 400;
  line-height: 30px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  vertical-align: top;
}
</style>